// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'

const pl = {
  paddingLeft: '3px',
}

const FormatBandwidthHeader = () => (
  <div
    className={'display-flex flex-direction-row flex-wrap-nowrap justify-content-end'}
    title={'Widest emission bandwidth of all modulations'}>
    <span>{'BW'}</span>
    <small style={pl}>{'(MHz)'}</small>
  </div>
)

export default FormatBandwidthHeader
